import React, { useMemo } from 'react'
import { Control, Controller } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../../ChallengeAdmin'
import { InputAdornment } from '@material-ui/core'
import YumField from '../../../../../components/YumInput/YumInput'
import ErrorMessage from '../../../../../components/ErrorMessage/ErrorMessage'
import { ReactComponent as DailyGoalInactiveIcon } from '../../../../../assets/v3/icons/daily-goal-inactive.svg'
import { getFieldName, getErrorMessage } from '../goalFormHelpers'

interface DailyMaxFieldProps {
  control: Control<FormData>
  fieldPrefix: string
  validationRules: {
    min?: number
    max?: number
  }
  endAdornment: string
  noTopMargin?: boolean
}

/**
 * Daily max input field.
 * Allows users to set a maximum daily amount with appropriate unit display.
 */
export default function DailyMaxField({
  control,
  fieldPrefix,
  validationRules,
  endAdornment,
  noTopMargin,
}: DailyMaxFieldProps) {
  // Memoize InputProps to prevent input from losing focus on re-render
  const inputProps = useMemo(
    () => ({
      endAdornment: (
        <InputAdornment style={{ flexShrink: 0, pointerEvents: 'none' }} position="end" disableTypography>
          {endAdornment}
        </InputAdornment>
      ),
      // style: {
      //   background: 'white',
      // },
    }),
    [endAdornment],
  )

  return (
    <Controller
      name={getFieldName('dailyMax', fieldPrefix) as any}
      rules={validationRules}
      control={control}
      render={({ field: { ref, ...otherField }, fieldState: { error } }) => (
        <>
          <YumField
            label={t`Daily limit per user`}
            type="number"
            inputProps={{ inputMode: 'numeric' }}
            onWheel={(e: { target: { blur: () => any } }) => e.target.blur()}
            error={!!error}
            InputProps={inputProps}
            startIcon={DailyGoalInactiveIcon}
            style={{
              marginBottom: 0,
              marginTop: noTopMargin ? 0 : '12px',
            }}
            {...otherField}
            value={otherField.value ?? ''}
            helperText={t`The highest activity level that will be taken into account for a user’s daily result. Higher values are reduced to this limit.`}
          />
          {error && getErrorMessage(error) && <ErrorMessage>{getErrorMessage(error)}</ErrorMessage>}
        </>
      )}
    />
  )
}
